import { render, staticRenderFns } from "./TenFormGridPanel.vue?vue&type=template&id=90c0959a&"
import script from "./TenFormGridPanel.vue?vue&type=script&lang=js&"
export * from "./TenFormGridPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports